module.exports = __webpack_public_path__ + "img/bed-2.b0a138d6.svg";